import { Observable, tap } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

import { API } from '@models/API/index';

import { platformAPI } from '@services/API/endpoints';

@Injectable({ providedIn: 'root' })
export class IdentityAuthAPI {
  constructor(private http: HttpClient) {}
  forgetPasswordPhoneNumber = signal<string | null>(null);

  login(
    payload: API.Identity.Auth.Login.Payload,
    loaderOptIn: boolean | string = true
  ) {
    return this.http.post<API.Identity.Auth.Login.Response>(
      platformAPI.identity.auth.login,
      payload,
      {
        headers: new HttpHeaders({ 'Loader-Opt-In': `${loaderOptIn}` }),
      }
    );
  }

  loginTwoFA(
    payload: API.Identity.Auth.Login.TwoFA.Payload,
    loaderOptIn: boolean | string = true
  ) {
    return this.http.post<API.Identity.Auth.Login.TwoFA.Response>(
      platformAPI.identity.auth.verifyTwoFA,
      payload,
      {
        // The response sets the refresh-token cookie (LEN-2764); a
        // cross-origin response only stores it for a credentialed request.
        withCredentials: true,
        headers: new HttpHeaders({ 'Loader-Opt-In': `${loaderOptIn}` }),
      }
    );
  }

  register(
    payload: API.Identity.Auth.Signup.Payload,
    loaderOptIn: boolean | string = true
  ) {
    return this.http.post<API.Identity.Auth.Signup.Response>(
      platformAPI.identity.auth.signup,
      payload,
      {
        headers: new HttpHeaders({ 'Loader-Opt-In': `${loaderOptIn}` }),
      }
    );
  }

  forgotPassword(
    payload: API.Identity.Auth.ForgotPassword.Payload,
    loaderOptIn: boolean | string = true
  ): Observable<API.Identity.Auth.ForgotPassword.Response> {
    return this.http
      .post<API.Identity.Auth.ForgotPassword.Response>(
        platformAPI.identity.auth.forgotPassword +
          `?email=${encodeURIComponent(payload.email)}`,
        undefined,
        {
          headers: new HttpHeaders({
            'Loader-Opt-In': `${loaderOptIn}`,
          }),
        }
      )
      .pipe(
        tap(res =>
          this.forgetPasswordPhoneNumber.set(
            res.CodeDeliveryDetails.Destination
          )
        )
      );
  }

  forgotPasswordConfirm(
    payload: API.Identity.Auth.ForgotPassword.Confirm.Payload,
    loaderOptIn: boolean | string = true
  ) {
    return this.http.post(
      platformAPI.identity.auth.confirmForgotPassword,
      payload,
      {
        headers: new HttpHeaders({ 'Loader-Opt-In': `${loaderOptIn}` }),
      }
    );
  }

  /**
   * Asks identity-api to revoke the session in Cognito and delete the
   * refresh-token cookie. Ending the session in the app is SessionService's job.
   */
  logout(loaderOptIn: boolean | string = true) {
    return this.http.post(platformAPI.identity.auth.logout, undefined, {
      withCredentials: true,
      headers: new HttpHeaders({
        'Loader-Opt-In': `${loaderOptIn}`,
        'Auth-Opt-In': 'true',
      }),
    });
  }
}
